import { activeConditionsQuery } from '../planner/context';
import type { ProtocolSpec } from '../planner/plan';
import { hyperthyroidismOngoingMeasurements, hypothyroidismOngoingMeasurements } from './thyroidOngoingMeasurements';

/**
 * The hypothyroidism ongoing-measurement protocol, ready for `planProtocol`. No variables: every
 * action is unconditional, so nothing needs deriving — but `activeConditionsQuery` is still listed,
 * because topic matching reads the patient's Conditions to find the topic this protocol belongs on.
 */
export const hypothyroidismOngoingMeasurementsProtocol: ProtocolSpec = {
  planDefinition: hypothyroidismOngoingMeasurements,
  valueSets: [],
  queries: [activeConditionsQuery],
  deriveVariables: () => ({}),
};

/** The hyperthyroidism ongoing-measurement protocol, ready for `planProtocol`. */
export const hyperthyroidismOngoingMeasurementsProtocol: ProtocolSpec = {
  planDefinition: hyperthyroidismOngoingMeasurements,
  valueSets: [],
  queries: [activeConditionsQuery],
  deriveVariables: () => ({}),
};
